import React from "react";
import "./reviews.scss";
import { Skeleton, Rating } from "@mui/material";

// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";

const ReviewSkeleton = () => {
  return (
    <div className="customer-reviews">
      <div className="customer-reviews-details">
        <div className="customer-name">
          <h4>
            <Skeleton animation="wave" width="100px" />
          </h4>
          <p>
            <Skeleton animation="wave" width="100px" />
          </p>
        </div>
        <div className="rating">
          <Rating
            name="read-only"
            value={4}
            readOnly
            sx={{ fontSize: "23px" }}
            icon={<StarRoundedIcon fontSize="inherit" />}
            emptyIcon={<StarRoundedIcon fontSize="inherit" />}
          />
        </div>
        <div className="verified-purchase">
          <VerifiedRoundedIcon className="icon" /> <p>Verified purchase</p>
        </div>
        <div className="review-description">
          <p>
            <Skeleton animation="wave" width="100%" />
          </p>
        </div>
        {/* <div className="like-dislike">
          <ThumbUpOutlinedIcon className="icon" />{" "}
          <Skeleton animation="wave">
            <p>123</p>
          </Skeleton>{" "}
          <ThumbDownOutlinedIcon className="icon" />{" "}
          <Skeleton animation="wave">
            <p>123</p>
          </Skeleton>
        </div> */}
      </div>
    </div>
  );
};

export default ReviewSkeleton;
